import { useEffect, useState } from "react";
import TicketServices from "../../../../Services/ticketService";
import "./card.css";
import { Logger } from "../../../../Logger/Logger";
import { useNavigate } from "react-router-dom";

const CardTicket = ({ data }) => {
  const navigate = useNavigate();
  return (
    <div className="CardWrapper" >
      <div className="CardContainer">
        <div className="flex flex-row justify-between">
          <p
            className="TicketName flex flex-row justify-start cursor-pointer"
            onClick={() => navigate(`/secured/viewTicket:${data.id}`)}
          >
            Ticket No. : {data.id}
          </p>
          <div className="flex flex-row justify-start ">
            <StatusIndicator status={data.status}></StatusIndicator>
          </div>
        </div>
        <div className="flex flex-row justify-between mt-[10px] mb-[12px]">
          <p className="TicketSubject">{data.subject}</p>
        </div>
        <div className="flex flex-row items-center justify-between">
          <p className="severity flex flex-row justify-start">
            {data.severity}
          </p>
          <div className="cat_style ">
            <p className="cat_name">{data.category}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatusIndicator = ({ status }) => {
  Logger.debug("status indicator", status);
  return (
    <>
      <div className="flex flex-row justify-start items-center">
        <div
          className={
            (status === "Open" && "sqr_box !bg-[#008FFB]") ||
            (status === "In Progress" && "sqr_box !bg-[#25B396]") ||
            (status === "Resolved" && "sqr_box !bg-[#2D033B]") ||
            (status === "Closed" && "sqr_box !bg-[#FF4560]")
          }
        ></div>
        <p className="status_name">
          {status}
          {/* {status === "In Progress" ? "Progress" : status} */}
        </p>
      </div>
    </>
  );
};

export default CardTicket;
